import React from "react";
import TableHead from "./TableHead";
import TableBody from "./TableBody";

const Table = ({ orders }) => {
  const hasExternalOrder = orders.some(
    (order) => order.order.externalOrderNumber
  );
  const empty = orders.length === 0;
  if (empty) {
    return (
      <div className="rounded-0 alert alert-warning m-0">
        Nenhuma venda efetuada até o momento.
      </div>
    );
  }
  return (
    <div className="table-responsive">
      <table className="table table-hover align-items-center table-flush">
        <TableHead hasExternalOrder={hasExternalOrder} />
        <TableBody orders={orders} />
      </table>
    </div>
  );
};

export default Table;



// WEBPACK FOOTER //
// ./src/components/Pages/Orders/Table.js